/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JobFileType,
    JobFileTypeFromJSON,
    JobFileTypeFromJSONTyped,
    JobFileTypeToJSON,
} from './JobFileType';
import {
    JobStatusType,
    JobStatusTypeFromJSON,
    JobStatusTypeFromJSONTyped,
    JobStatusTypeToJSON,
} from './JobStatusType';
import {
    JobType,
    JobTypeFromJSON,
    JobTypeFromJSONTyped,
    JobTypeToJSON,
} from './JobType';

/**
 * 
 * @export
 * @interface JobResponse
 */
export interface JobResponse {
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    info: string | null;
    /**
     * 
     * @type {JobType}
     * @memberof JobResponse
     */
    type: JobType;
    /**
     * 
     * @type {Date}
     * @memberof JobResponse
     */
    createdAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof JobResponse
     */
    startedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof JobResponse
     */
    finishedAt: Date | null;
    /**
     * 
     * @type {number}
     * @memberof JobResponse
     */
    processedItemCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobResponse
     */
    totalItemCount: number | null;
    /**
     * 
     * @type {JobStatusType}
     * @memberof JobResponse
     */
    status: JobStatusType;
    /**
     * 
     * @type {JobFileType}
     * @memberof JobResponse
     */
    inputFileStatus: JobFileType;
    /**
     * 
     * @type {JobFileType}
     * @memberof JobResponse
     */
    reportFileStatus: JobFileType;
    /**
     * 
     * @type {JobFileType}
     * @memberof JobResponse
     */
    rejectionFileStatus: JobFileType;
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    errorMessage: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobResponse
     */
    isManagementAllowed: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    username: string | null;
}

export function JobResponseFromJSON(json: any): JobResponse {
    return JobResponseFromJSONTyped(json, false);
}

export function JobResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'info': json['info'],
        'type': JobTypeFromJSON(json['type']),
        'createdAt': (json['createdAt'] === null ? null : new Date(json['createdAt'])),
        'startedAt': (json['startedAt'] === null ? null : new Date(json['startedAt'])),
        'finishedAt': (json['finishedAt'] === null ? null : new Date(json['finishedAt'])),
        'processedItemCount': json['processedItemCount'],
        'totalItemCount': json['totalItemCount'],
        'status': JobStatusTypeFromJSON(json['status']),
        'inputFileStatus': JobFileTypeFromJSON(json['inputFileStatus']),
        'reportFileStatus': JobFileTypeFromJSON(json['reportFileStatus']),
        'rejectionFileStatus': JobFileTypeFromJSON(json['rejectionFileStatus']),
        'errorMessage': json['errorMessage'],
        'isManagementAllowed': json['isManagementAllowed'],
        'username': json['username'],
    };
}

export function JobResponseToJSON(value?: JobResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'info': value.info,
        'type': JobTypeToJSON(value.type),
        'createdAt': (value.createdAt === null ? null : value.createdAt.toISOString()),
        'startedAt': (value.startedAt === null ? null : value.startedAt.toISOString()),
        'finishedAt': (value.finishedAt === null ? null : value.finishedAt.toISOString()),
        'processedItemCount': value.processedItemCount,
        'totalItemCount': value.totalItemCount,
        'status': JobStatusTypeToJSON(value.status),
        'inputFileStatus': JobFileTypeToJSON(value.inputFileStatus),
        'reportFileStatus': JobFileTypeToJSON(value.reportFileStatus),
        'rejectionFileStatus': JobFileTypeToJSON(value.rejectionFileStatus),
        'errorMessage': value.errorMessage,
        'isManagementAllowed': value.isManagementAllowed,
        'username': value.username,
    };
}

